import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Show loading until auth state is ready
  if (loading)
    return (
      <p className="text-center mt-6 text-gray-600">
        Loading authentication...
      </p>
    );

  // If no user, redirect to login
  if (!user) return <Navigate to="/login" replace />;

  // User is authenticated, render children
  return children;
};

export default ProtectedRoute;
